export function initLoading(mapDivId) {
    const loading = document.querySelector('#loadingOverlay');
    if (!loading) {
        let overlayDiv = document.createElement('div');
        overlayDiv.className = "overlay";
        overlayDiv.id = "loadingOverlay"
        overlayDiv.style.display = "none";
        const mapDiv = document.querySelector(mapDivId);
        mapDiv.appendChild(overlayDiv);
        loadingStart(document.querySelector('#loadingOverlay'))
    }
}

export function showHideLoading(Params){
    const loadingDiv = document.querySelector('#loadingOverlay');
    loadingDiv.style.display = Params;
}

function loadingStart(parentDivId) {
    let loadingContainerDiv = document.createElement('div');
    loadingContainerDiv.className = "lds-facebook";
    let firstDiv = document.createElement('div');
    let sndDiv = document.createElement('div');
    let thirdDiv = document.createElement('div');
    parentDivId.appendChild(loadingContainerDiv);
    const divLoadingParent = document.querySelector('.lds-facebook');
    divLoadingParent.appendChild(firstDiv);
    divLoadingParent.appendChild(sndDiv);
    divLoadingParent.appendChild(thirdDiv);
}